module.exports = __webpack_public_path__ + "static/media/marcos-1.901cd5bd.jpeg";